/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Secondsubjectgraduationcoursetype4Inputs */

const de__field_secondsubjectgraduationcoursetype4 = /** @type {(inputs: _Field_Secondsubjectgraduationcoursetype4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweitfach Kursart`)
};

/**

* @param {_Field_Secondsubjectgraduationcoursetype4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_secondsubjectgraduationcoursetype4 = /** @type {((inputs?: _Field_Secondsubjectgraduationcoursetype4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Secondsubjectgraduationcoursetype4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_secondsubjectgraduationcoursetype4(inputs)
});
export { _field_secondsubjectgraduationcoursetype4 as "_field_secondSubjectGraduationCourseType" }